const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Vpay24 = function Vpay24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fill: "#1834CB",
      d: "M20.615 3H4v18h16.615V3Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#fff",
      d: "M20.2 3.415H4.415V14.69H20.2V3.415Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#1834CB",
      d: "m16.3 5.462-3.097 7.393H11.18l-1.525-5.9c-.092-.362-.173-.497-.454-.65-.461-.25-1.221-.484-1.888-.628l.044-.215h3.256c.415 0 .789.276.881.752l.807 4.277 1.99-5.03H16.3Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#fff",
      d: "M8.137 19.42v-3.434h1.256c.246 0 .464.039.65.115a.927.927 0 0 1 .437.356c.104.162.156.367.156.618 0 .252-.051.454-.156.616a.925.925 0 0 1-.438.354 1.723 1.723 0 0 1-.65.115h-.647v1.26h-.61.002Zm1.165-2.955h-.557v1.238h.557c.225 0 .398-.047.518-.137.12-.093.178-.252.178-.481 0-.23-.058-.393-.178-.484-.12-.09-.29-.134-.518-.134v-.002ZM10.663 19.42l1.275-3.434h.647l1.275 3.434h-.65l-.335-.94h-1.313l-.335.94h-.564Zm1.047-1.402h1.01l-.497-1.387h-.01l-.5 1.387h-.003ZM14.93 19.42v-1.488l-1.212-1.946h.674l.899 1.49h.015l.889-1.49h.552l-1.212 1.941v1.493h-.606Z",
    })
  );
};
Vpay24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24",
};
var Vpay32 = function Vpay32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      width: "31",
      height: "23",
      x: ".5",
      y: ".5",
      fill: "#fff",
      stroke: "#CCC",
      rx: "3.5",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#1834CB",
      d: "M23.692 3.5H8v17h15.692v-17Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#fff",
      d: "M23.3 3.892H8.392V14.54H23.3V3.892Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#1834CB",
      d: "m19.616 5.825-2.924 6.982h-1.91l-1.44-5.573c-.088-.34-.164-.468-.429-.613-.436-.235-1.153-.457-1.783-.593l.042-.203h3.074c.393 0 .745.26.833.71l.761 4.04 1.88-4.75h1.896Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#fff",
      d: "M11.908 19.008v-3.243h1.185c.233 0 .438.036.614.108a.875.875 0 0 1 .412.337c.1.152.148.346.148.583 0 .238-.048.43-.147.582a.874.874 0 0 1-.413.334c-.178.072-.38.108-.614.108h-.611v1.19h-.577.003Zm1.1-2.791h-.526v1.169h.526c.212 0 .376-.044.489-.13.113-.087.168-.237.168-.454 0-.216-.055-.37-.168-.456-.113-.086-.275-.127-.49-.127v-.002ZM14.293 19.008l1.204-3.243h.61l1.205 3.243h-.614l-.316-.889h-1.24l-.317.889h-.532Zm.99-1.324h.952l-.468-1.31h-.01l-.473 1.31h-.002ZM18.322 19.008v-1.405l-1.144-1.839h.637l.849 1.408h.013l.84-1.408h.521l-1.144 1.834v1.41h-.572Z",
    })
  );
};
Vpay32.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "24",
  fill: "none",
  viewBox: "0 0 32 24",
};
const sizeMap = {
  24: Vpay24,
  32: Vpay32,
};
export function Vpay(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Vpay' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
